import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function StaffingPayslipPanel({ token }) {
  const [payslips, setPayslips] = useState([]);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    if (!token || !API_URL) return;
    try {
      const res = await fetch(`${API_URL}/api/candidate/staffing/payslips`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to load payslips');
      setPayslips(data.payslips || []);
    } catch (e) {
      setError(e.message);
    }
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  if (error) return <Alert severity="warning">{error}</Alert>;

  if (!payslips.length) {
    return <Typography color="text.secondary">No payslips yet. Payslips are generated after monthly payroll.</Typography>;
  }

  return (
    <Stack spacing={1}>
      {payslips.map((p) => (
        <Box key={p.id} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography fontWeight={600}>
              {String(p.month).padStart(2, '0')}/{p.year}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Net INR {Number(p.net_pay || 0).toFixed(2)} · Paid days {p.paid_days}
            </Typography>
          </Box>
          <Button
            size="small"
            variant="outlined"
            onClick={async () => {
              try {
                const res = await fetch(`${API_URL}/api/candidate/staffing/payslips/${p.id}/download`, {
                  headers: { Authorization: `Bearer ${token}` }
                });
                if (!res.ok) throw new Error('Download failed');
                const blob = await res.blob();
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `payslip_${p.month}_${p.year}.pdf`;
                a.click();
                URL.revokeObjectURL(url);
              } catch (e) {
                setError(e.message);
              }
            }}
          >
            Download
          </Button>
        </Box>
      ))}
    </Stack>
  );
}
